var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceloomFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 540,
    height: 100,
    viewBox: "0 0 540 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5,9) scale(0.82)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4,
    fill: "#3250FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 8.3,
    width: 47.6,
    height: 7.8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 8.3,
    width: 10.2,
    height: 45.9,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 8.3,
    width: 7.3,
    height: 45.9,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 24.9,
    width: 47.6,
    height: 10.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 43.9,
    width: 9.2,
    height: 47.8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.7,
    y: 43.9,
    width: 10.2,
    height: 47.8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.1,
    y: 43.9,
    width: 10.2,
    height: 10.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.1,
    y: 62.9,
    width: 45.1,
    height: 10.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.1,
    y: 82.4,
    width: 45.1,
    height: 9.3,
    fill: "#FFFFFF"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 73,
    fontFamily: "-apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 600,
    fontSize: 70,
    letterSpacing: -2.5,
    fill: "#0F172A"
  }, "ServiceLoom")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceloomFull);
export default __webpack_public_path__ + "static/media/serviceloom-full.dde13a76f2d58efc23c79298d94f065b.svg";
export { ForwardRef as ReactComponent };